import React from 'react';
import { Package, Truck, ShoppingBag, ArrowLeftRight, ClipboardList, BarChart3 } from 'lucide-react';
import { InventoryPageShell } from './InventoryPageShell';
import { StockItemsTab } from './StockItemsTab';
import { SuppliersTab } from './SuppliersTab';
import { PurchasesTab } from './PurchasesTab';
import { TransfersTab } from './TransfersTab';
import { RecipesTab } from './RecipesTab';
import { InventoryReportsTab } from './InventoryReportsTab';

export const InventoryStockPage: React.FC = () => (
  <InventoryPageShell title="Stock Items" description="Track ingredients and supplies, stock levels and adjustments" icon={Package}>
    {({ org, restaurantId }) => <StockItemsTab org={org} restaurantId={restaurantId} />}
  </InventoryPageShell>
);

export const InventorySuppliersPage: React.FC = () => (
  <InventoryPageShell title="Suppliers" description="Manage the vendors you purchase stock from" icon={Truck}>
    {({ org, restaurantId }) => <SuppliersTab org={org} restaurantId={restaurantId} />}
  </InventoryPageShell>
);

export const InventoryPurchasesPage: React.FC = () => (
  <InventoryPageShell title="Purchases" description="Record purchases and receive goods into stock" icon={ShoppingBag}>
    {({ org, restaurantId }) => <PurchasesTab org={org} restaurantId={restaurantId} />}
  </InventoryPageShell>
);

export const InventoryTransfersPage: React.FC = () => (
  <InventoryPageShell title="Stock Transfers" description="Move stock to and from other restaurants in your organization" icon={ArrowLeftRight}>
    {({ org, restaurantId }) => <TransfersTab org={org} restaurantId={restaurantId} />}
  </InventoryPageShell>
);

export const InventoryRecipesPage: React.FC = () => (
  <InventoryPageShell title="Recipes" description="Map menu items to ingredients for automatic stock deduction" icon={ClipboardList}>
    {({ org, restaurantId }) => <RecipesTab org={org} restaurantId={restaurantId} />}
  </InventoryPageShell>
);

export const InventoryReportsPage: React.FC = () => (
  <InventoryPageShell title="Inventory Reports" description="Low stock, valuation and consumption insights" icon={BarChart3}>
    {({ org, restaurantId }) => <InventoryReportsTab org={org} restaurantId={restaurantId} />}
  </InventoryPageShell>
);
